import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

const Workdetails = () => {
  return (
    <div>
      <section className=" about-section_1 clearfix">
        <div className="container">
          <div className="row">
            <div className="col-xl-10 col-lg-10 col-md-10 col-sm-12 mx-auto">
              <div className="">
                <div className="section-title">
                  <div className="title-header">
                    <h2 className="title text-center"
                    //</div>style={{ marginTop: "40px" }}
                    >
                      Our Work
                    </h2>
                  </div>
                  <div className="title-desc">
                    <ScrollAnimation animateIn="zoomIn">
                      <p className="text-center">
                        As a trusted Display Racks Manufacturer and Retail
                        Display Rack Supplier in India, we specialize in
                        designing and manufacturing high-quality Free Standing
                        Display Units, Table Top Display Stands, Counter Top
                        Display Units, and Custom POS Display Units for retail
                        stores, supermarkets, exhibitions, and promotional
                        branding requirements. Our complete In-Store Display
                        Solutions include Retail Merchandising Displays,
                        Promotional Display Stands, POP Display Stand
                        Manufacturing, Acrylic Display Stand Supply, Supermarket
                        Display Racks, and Product Display Fixtures that help
                        brands improve product visibility and customer
                        engagement. With expertise in Custom Display Rack
                        Manufacturing, Metal Stand Fabrication, Racks
                        Fabrication, and Metal Fabrication, we deliver durable,
                        attractive, and customized display solutions tailored to
                        meet modern retail and merchandising needs across India.
                      </p>
                    </ScrollAnimation>
                    <ScrollAnimation animateIn="zoomIn">
                      <p className="text-center">
                        We are a leading manufacturer and supplier of Display
                        Racks, Free Standing Display Units, Table Top Display
                        Stands, Counter Top Display Units, and Custom POS
                        Display Units, offering complete In-Store Display
                        Solutions for retail stores, supermarkets, and
                        promotional branding needs across India. Our expertise
                        includes Retail Merchandising Displays, POP Display
                        Stand Manufacturing, Acrylic Display Stand Supply,
                        Supermarket Display Racks, Product Display Fixtures,
                        Custom Display Rack Manufacturing, Metal Stand
                        Fabrication, Racks Fabrication, and Metal Fabrication
                        solutions designed to enhance product visibility,
                        improve customer engagement, and support effective
                        retail merchandising for all types of businesses
                      </p>
                    </ScrollAnimation>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Workdetails;
